<template>
  <div class="lwBottomChatBox clear-fix" ref="lwBottomChatBox" @click="getheight">
    <div class="textarea">
      <van-cell-group inset>
        <van-field
            class="mytextarea"
            ref="fieldPhone"
            v-model="txtValue"
            rows="1"
            :autosize="autosize"
            type="textarea"
            size="small"
            arrow-direction="down"
            :placeholder="placeholder"
            @focus="onFocus"
            @blur="onBlur"
        />
      </van-cell-group>
    </div>

    <div v-if="isFouce">
      <div class="sendBtn" @click="sendBtn">发送</div>
    </div>
    <div v-else>
      <div class="lvChatFlower" @click="chatFlower"></div>
      <div class="lvChatFast" @click="chatFast"></div>
    </div>

  </div>
</template>

<script>
export default {
  name: "lvBottomChat",
  created() {
    console.log("==================================屏幕宽度：")
    console.log(window.innerWidth)
    this.autosize.maxHeight = window.innerWidth/6
    console.log(this.autosize.maxHeight)
  },
  data(){
    return {
      txtValue: '',
      autosize: { maxHeight: 100 },
      isFouce: false,
      placeholder: "我来说两句",
      altUserId: 0,
      altUserName: '',
    }
  },
  mounted() {
    // console.log("--hh--------------------"+this.$refs.lwBottomChatBox.offsetHeight)
    // let obj = this.$refs.lwBottomChatBox
    // let h = window.getComputedStyle(obj).height;  //通过这个方法，获取宽高
    // console.log("--ww--------------------"+h)
  },
  methods:{
    getheight(){
      // console.log("-getheight-hh--------------------"+this.$refs.lwBottomChatBox.offsetHeight)
      // let obj = this.$refs.lwBottomChatBox
      // let h = window.getComputedStyle(obj).height;  //通过这个方法，获取宽高
      // console.log("-getheight-ww--------------------"+h)
    },
    onFocus(){
      this.isFouce = true
      this.$emit("onFocus")
    },
    onBlur(){

      this.placeholder = "我来说两句"
      setTimeout(()=>{
        console.log('onBlur')
        this.isFouce = false
        this.altUserId = 0
        this.altUserName = ''
      }, 150)
    },
    sendBtn(){
      console.log('发送数据')
      if(this.txtValue == ''){
        return
      }
      let obj = {
        'content': this.txtValue,
        'altUserId': this.altUserId,
        'altUserName': this.altUserName
      }
      this.$emit("sendContent",obj)
      this.txtValue = ''
    },
    chatFlower(){
      this.$emit("chatFlower")
    },
    chatFast(){
      this.$emit("chatFast")
    },

    altSomeOne(obj){
      console.log(obj.userId+": "+ obj.userName)
      this.altUserId = obj.userId
      this.altUserName = obj.userName
      this.$nextTick(() => {
        this.placeholder = "@"+obj.userName
        this.$refs.fieldPhone.focus()
      });

    }
  }
}
</script>

<style scoped>
.lwBottomChatBox{
  position: relative;
  width: 100%;
  /*height: 300px;*/
}
.textarea{
  float: left;
  width: 72%;
  padding-top: 20px;
  padding-bottom: 20px;
  color: black;
}
.mytextarea{
  margin-top: 30px;
  margin-bottom: 30px;
  padding-top: 0px;
  padding-bottom: 0px;
  font-size: 40px;
  line-height: 60px;
  min-height: 60px;
  overflow-y: scroll;
}
.mytextarea::-webkit-scrollbar {
  display: none;
}
.mytextarea::-webkit-scrollbar-thumb {
  display: none;
}

.sendBtn{
  float: right;
  width: 250px;
  height: 110px;
  line-height: 110px;
  background-color: #009bff;
  border-radius: 20px;
  color: whitesmoke;
  font-size: 45px;
  text-align: center;
  letter-spacing: 6px;
  margin-right: 40px;
  margin-top: 30px;
}
.lvChatFast,
.lvChatFlower{
  float: right;
  width: 109px;
  height: 98px;
  /*background-color: #ee0a24;*/
  background-image: url("../../../assets/live/chat.png");
  background-size: 109px 98px;
  background-repeat: no-repeat;
  background-position: center;
  margin-right: 40px;
  margin-top: 32px;
}
.lvChatFlower{
  background-image: url("../../../assets/live/flowerS.png");
}
</style>